import { render, staticRenderFns } from "./inmueble-burbuja-propietarios-consolidados.vue?vue&type=template&id=f537f542&"
import script from "./inmueble-burbuja-propietarios-consolidados.vue?vue&type=script&lang=js&"
export * from "./inmueble-burbuja-propietarios-consolidados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports